import React from 'react';
import 'src/style/components/afterLoginTemplate.scss';
import { Footer } from './Footer';
import { Header } from './Header';

// #region -------------- Component -------------------------------------------------------------------

export class AfterLoginTemplate extends React.Component {
  public render() {
    return (
      <div className='rb-after-login-template'>
        <Header />

        <div className='rb-after-login-content'>
          {this.props.children}
        </div>

        <Footer />
      </div>
    );
  }
}

// #endregion
